import {CommonService} from '@/api'
import {getLanguage} from "@/utils/auth";

const language=getLanguage()

const getDefaultState = () => {
  return {
    system_constants: {},
    constants: {},
    banks: [],
    cachedViews: []
  }
}

const state = getDefaultState()

const mutations = {
  SET_SYSTEM_CONSTANTS: (state, data) => {
    state.system_constants = Object.fromEntries(
        Object.entries(data).map(([key, items]) => [
          key,
          items.map(({code, name, enName}) => ({
            code,
            name: language === 'zh' ? name : enName && enName !== '' ? enName : name
          }))
        ])
    );
  },
  SET_CONSTANTS: (state, data) => {
    data.operatorOuterStatusCode = []
    data.progressStatusCode = []
    data.operatorOuterStatus.forEach(_ => {
      if (!data.operatorOuterStatusCode.includes(_.code)) {
        data.operatorOuterStatusCode.push(_.code)
      }
    })
    data.purchasePaymentTransactionProgressConstantStatus.forEach(_ => {
      if (!data.progressStatusCode.includes(_.code)) {
        data.progressStatusCode.push(_.code)
      }
    })

    state.constants = Object.fromEntries(
        Object.entries(data).map(([key, items]) => [
          key,
          items.map(({code, name, enName}) => ({
            code,
            name: language === 'zh' ? name : enName && enName !== '' ? enName : name
          }))
        ])
    );
  },
  SET_BANKS: (state, data) => {
    state.banks = data
  },
  ADD_CACHED_VIEW: (state, view) => {
    if (state.cachedViews.includes(view.name)) return
    if (!view.meta.noCache) {
      state.cachedViews.push(view.name)
    }
  }
}

const actions = {
  getSystemContants({commit}) {
    return new Promise((resolve, reject) => {
      CommonService.all_system_constants().then(response => {
        sessionStorage.setItem('virtualNumber', JSON.stringify(response.data['default.virtual.card.merchant.number'][0]))
        sessionStorage.setItem('virtualNumber2', JSON.stringify(response.data['default.van.menu.show.merchant.number'][0]))
        commit('SET_SYSTEM_CONSTANTS', response.data)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getContants({commit}) {
    return new Promise((resolve, reject) => {
      CommonService.all_constants().then(response => {
        commit('SET_CONSTANTS', response.data)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getBanks({commit}) {
    return new Promise((resolve, reject) => {
      CommonService.all_banks().then(response => {
        commit('SET_BANKS', response.data)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  addCachedView({commit}, view) {
    commit('ADD_CACHED_VIEW', view)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
